<template>
    <b-container>
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading" style="width: 3rem; height: 3rem"></b-spinner>
      </div>
      <b-row>
        <b-col md="12">
          <BudgetChart  />
        </b-col>
      </b-row>
     
    </b-container>
  </template>
  
  <script>

  import BudgetChart from "./BudgetChart";
  import { BContainer, BRow, BCol, BSpinner } from "bootstrap-vue";
  import { mapActions, mapGetters } from "vuex";
  export default {
    components: {
      BContainer,
      BRow,
      BudgetChart,
      BCol,
      BSpinner,
    },
   
  };
  </script>
  